export default {
  SET_PROGRESS_ANALYSIS: (state, payload) => (state.progressanalysis = payload),
};
